<img
  [src]="imgSrc"
  [alt]="alt"
  [class]="class"
  (error)="onError()"
/>
